class UserListController {
  constructor($scope, messageService, usersService, permissionsService) {
    this.usersService = usersService;
    this.messageService = messageService;
    this.$scope = $scope;
    this.user = permissionsService.user;
  }

  $onInit() {
    this.updatePaging();
    this.$scope.$watch(
      function (scope) {
        return scope.current_page;
      },
      function (newVal, oldVal, scope) {
        if (newVal !== oldVal){
          if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered){
            scope.$ctrl.users = undefined;
            scope.$ctrl.usersService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(response => {
              scope.$ctrl.users = response;
              scope.$ctrl.loading = false;
            });
          }
          else{
            scope.$ctrl.usersService.findAll(newVal, scope.per_page)
              .then(list => scope.$ctrl.users = list);
          }
        }
    });
  }

  updatePaging(){
    this.$scope.per_page = this.users.per_page;
    this.$scope.current_page = this.users.current_page;
    this.$scope.total = this.users.total;
  }

  onDelete(user) {
    var returnPage = (this.users.data.length > 1 ? this.$scope.current_page : (this.$scope.current_page-1));
    this.usersService.delete(user)
      .then(() => this.usersService.findAll(returnPage))
      .then(list => {
        this.$scope.total = list.total;
        this.$scope.current_page = list.current_page;
        this.users = list;
      })
      .then(() => {
        this.messageService.success(`User <strong>${user.user_metadata.first_name} ${user.user_metadata.last_name}</strong> was successfully deleted.`);
        this.messageService.push();
      })
      .catch((error) => {
        this.messageService.failure(`User <strong>${user.user_metadata.first_name} ${user.user_metadata.last_name}</strong> could not be successfully deleted: ${error.statusText}`);
        this.messageService.push();
      });
  }

  filter(){
    if (!this.loading && this.filtertext){
      this.startFilter();
      this.usersService.search(this.filtertype, this.filtertext).then(response => {
        this.isFiltered = true;
        this.endFilter(response);
      });
    }
  }

  clearfilter(){
    if (this.isFiltered) {
      this.startFilter();
      this.usersService.findAll(1, 20).then(response => {
        this.isFiltered = false;
        this.endFilter(response);
      });
    }
  }

  filtertypeChange() {
    switch(this.filtertype) {
      case 'role':
        this.filtertext = 'admin';
        break;
      default:
        this.filtertext = '';
        break;
    }
  }

  startFilter(){
    this.loading = true;
    this.users = undefined;
  }

  endFilter(response){
    this.users = response;
    this.updatePaging();
    this.loading = false;
  }
}

UserListController.$inject = [ '$scope', 'messageService', 'usersService', 'permissionsService' ];

export default UserListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/user/controllers/user.list.controller.js